<template>
	<div v-if='display' class="tooltip_warn">
		<div class="tooltip_warn_close" @click='close'>x</div>
		Для данного вида мероприятий возможен ввод только целочисленных значений
	</div>
</template>

<script>
	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'tooltipWarn',
		data: function () { 
			return {
				show_force: false,
				closed: false
			}
		},
		methods: {
			close () {
				this.closed = true
				this.show_force = false
			}
		},
		props: ['value', 'typeIsRad', 'id'],
		computed: {
			display () {
				//console.warn(this.$props, this.show_force, this.closed, this.typeIsRad && !Number.isInteger(Number(this.value)))
				if(this.show_force)
					return true

				if(this.closed)
					return false

				if(this.typeIsRad && !Number.isInteger(Number(this.value)))
					return true

				return false
			}
		},
		watch: {
			typeIsRad () {
				this.closed = false
				this.show_force = false
			},
			value (e)
			{
				if(Number.isInteger(Number(e)))
					this.closed = false
			}
		},
		created: function () {
			EventBus.$on('show_tooltip_mzl_add', (data) => {
				if(data.id == this.$props.id)
					this.show_force = true
			})
		}
	}
</script>

<style scoped>
	.tooltip_warn {
	    width: 200%;
	    background-color: black;
	    color: #fff;
	    text-align: center;
	    padding: 10px 5px;
	    border-radius: 6px;
        position: absolute;
	    z-index: 1;
	    font-size: 14px;
	    bottom: 30px;
	    left: -50%;
	}

	.tooltip_warn::after {
		content: "";
	    position: absolute;
	    top: 100%;
	    left: 50%;
	    margin-left: -5px;
	    border-width: 5px;
	    border-style: solid;
	    border-color: #555 transparent transparent transparent;
	}

	.tooltip_warn_close {
		position: absolute;
		right: 0px;
		top: -2px;
		font-size: 15px;
		border: 1px solid white;
		border-bottom-left-radius: 6px;
		width: 18px;
		height: 22px;
		line-height: 20px;
		padding-left: 1px;
	}

	.tooltip_warn_close:hover {
		font-weight: bold;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// tooltipWarn.vue?f7e59f38